<template>
    <div class="faq-category-nav-wrapper">
        <div class="category-nav-list">
            <draggable
                group="navparts"
                :list="categoriesIn"
                @change="categoryOrderChanged()"
                ghost-class="ghost">
                <design-2021-admin-afaq-question-nav-component
                    v-for="category in categoriesIn"
                    @hold="hold($event)"
                    @continue="cont($event)"
                    :key="category.id"
                    @selected-category="
                        $emit('selected-category', $event);
                        selected = $event;
                    "
                    :categoryIn="category"
                    :selected="category.id === selected">
                </design-2021-admin-afaq-question-nav-component>
            </draggable>
        </div>

        <div class="add-faq-category">
            <b-button
                class="btn-add btn-add-category"
                v-b-modal="'faq-add-category-modal'"
                variant="primary">
                {{ $t('admin.new_category') }}
            </b-button>

            <design-2021-add-category-modal-component :order-in="order"></design-2021-add-category-modal-component>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { ords } from '../../../../app';

export default {
    name: 'design-2021-admin-afaq-category-nav-component',
    components: {
        draggable,
    },
    props: ['categoriesIn'],
    data() {
        return {
            selected: null,
            categories: this.categoriesIn,
            holds: [],
        };
    },
    computed: {
        order() {
            return this.categoriesIn.length;
        },
    },
    watch: {
        categoriesIn: function () {
            for (const category of this.categoriesIn) {
                if (category.id === this.selected) {
                    return;
                }
            }
            if (!this.categoriesIn.length) {
                return;
            }
            this.selectCategory(this.categoriesIn[0].id);
        },
    },
    methods: {
        selectCategory(id) {
            this.selected = id;
            const name = 'afaq-category-edit-selected-category';
            localStorage.setItem(name, id);
            this.$emit('selected-category', id);
        },

        categoryOrderChanged() {
            let blocks = [];

            this.categoriesIn.forEach((cat, i) => {
                blocks.push({
                    id: cat.id,
                    order: i,
                });
            });

            const data = {
                blocks: blocks,
            };

            this.axios.post(this.routes.afaqCategoryOrder(), data).then(
                (response) => {
                    ords.hold();
                    this.categoriesIn.forEach((cat, i) => {
                        cat.update({ order: i });
                    });
                    ords.continue();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        categoryAdded(id) {
            this.selectCategory(id);
        },

        hold(key) {
            for (const h of this.holds) {
                if (key === h) {
                    return;
                }
            }
            this.holds.push(key);
            ords.hold();
        },

        cont(key) {
            this.holds = this.holds.filter((k) => k !== key);
            if (!this.holds.length) {
                ords.continue();
            }
        },
    },

    mounted() {
        const name = 'afaq-category-edit-selected-category';
        const storage_value = parseInt(localStorage.getItem(name));
        if (storage_value) {
            for (const category of this.categoriesIn) {
                if (category.id === storage_value) {
                    this.selected = storage_value;
                    this.$emit('selected-category', storage_value);
                }
            }
        } else {
            if (this.categoriesIn.length) {
                this.selected = this.categoriesIn[0].id;
                this.$emit('selected-category', this.categoriesIn[0].id);
            }
        }
    },
};
</script>

<style scoped lang="scss">
.ghost {
    background-color: darken($secondary-background-color, 10%);
}

.faq-category-nav-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.add-faq-category {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
